'use strict';

import React from 'react';
import BusinessMedia from './BusinessMediaComponent'
import API from 'sources/API';
import { base64encode, utf16to8 } from '../utils'
require('styles/BusinessMediaList.scss');

class BusinessMediaListComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgs: []
    }
    this.showPic = this.showPic.bind(this)
  }
  componentDidMount(){
    if(API.isWechat){
      fetch(API.getWechatConfig).then(res=>res.json()).then(json=>{
        if(json.appId) {
            window.wx.config(json);
        }
      })
    }
    window.scrollTo(0, 0);
  }
  showPic(url){
    if(!this.state.imgs || !this.state.imgs.length){
      let {medias,watermark} = this.props;
      let imgs = new Array();
      watermark = base64encode(utf16to8(`@${watermark}`)).replace('/','|');
      medias.forEach(function(media){
        let temp = media.images.origin?media.images.origin:[];
        imgs = imgs.concat(temp);
      });
      imgs = imgs.map(img => {
        return img.replace('!liorigin',`!/fw/750/force/true/watermark/text/${watermark}/size/30/font/simyou/color/FFFFFF/align/southeast/format/png`)
      })
      this.state.imgs = imgs
    }
		if(API.isWechat){
      window.wx.previewImage({
        current: url,
        urls: this.state.imgs?this.state.imgs:[]
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    if(!this.state.imgs.length){
      let {medias,watermark} = nextProps;
      let imgs = new Array();
      watermark = base64encode(utf16to8(`@${watermark}`)).replace('/','|');
      medias.forEach(function(media){
        let temp = media.images.origin?media.images.origin:[];
        imgs = imgs.concat(temp);
      });
      imgs = imgs.map(img => {
        return img.replace('!liorigin',`!/fw/750/force/true/watermark/text/${watermark}/size/30/font/simyou/color/FFFFFF/align/southeast/format/png`)
      })
      this.setState({imgs:imgs});
    }
  }
  render(){
    let { medias, watermark, product, view_article, ad_url } = this.props
    let productReveal;
    if(product){
      productReveal = (
        <div className="bg-white product-info">
          <a href={product.url}>
            <div className="product">
              <div className="cover">
                <img src={product.cover.big.replace('!li750','')} />
                <span className="price">¥{product.price} 起</span>
              </div>
              <div className="title fz-14 mt-15">
                <span style={{fontWeight:'500',color:'#607fa6'}}>行程推荐：</span>{product.title}
              </div>
            </div>
          </a>
        </div>
      );
    }
  	return (
  	  <div className="Business-media-list-component">
        {medias&&medias.map((media, index) => <BusinessMedia key={media._id} watermark={watermark} media={media} index={index} showPic={this.showPic} /> )}
        {productReveal}
        <div>
          <div className='view-count float left'>
            阅读 {(view_article)||0}
          </div>
          <div className='view-count float right'>
            禁止转载
          </div>
          <div className="clear"></div>
        </div>
 				<div className="bottom"></div>
				<div className="ads">
					<img src={ad_url} />
				</div>
        <div className="support fz-12 mt-40">小地球提供内容技术支持</div>
  	  </div>
  	);
  }
}

BusinessMediaListComponent.displayName = 'BusinessMediaListComponent';

export default BusinessMediaListComponent;



// WEBPACK FOOTER //
// ./src/components/BusinessMediaListComponent.js